// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../../atoms/Icon/IconV5.bs.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function iconFromType(x) {
  if (x === "okCircledAlt") {
    return "ok-circled-alt";
  } else if (x === "unable") {
    return "unable";
  } else if (x === "ok") {
    return "ok-semicircled";
  } else {
    return "bullet";
  }
}

function List__Jsx3(props) {
  let __iconClassName = props.iconClassName;
  let __className = props.className;
  let __itemSpacingClassName = props.itemSpacingClassName;
  let __type_ = props.type_;
  let type_ = __type_ !== undefined ? __type_ : "bullet";
  let itemSpacingClassName = __itemSpacingClassName !== undefined ? __itemSpacingClassName : "mt-9";
  let className = __className !== undefined ? __className : "";
  let iconClassName = __iconClassName !== undefined ? __iconClassName : "text-tan-blue-500";
  let icon = iconFromType(type_);
  return JsxRuntime.jsx("ul", {
    children: props.items.map((item, idx) => JsxRuntime.jsxs("li", {
      children: [
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(IconV5.make, {
            icon: icon,
            size: 24,
            className: iconClassName
          }),
          className: TailwindMerge.twMerge([
            type_ === "bullet" ? "mr-1" : "mr-2.5",
            "mt-0.5"
          ])
        }),
        JsxRuntime.jsx("span", {
          children: item
        })
      ],
      className: TailwindMerge.twMerge([
        "flex",
        idx === 0 ? "mt-0" : itemSpacingClassName,
        className
      ])
    }, idx.toString())),
    className: "list-none m-0 p-0 text-lg leading-[1.5] font-medium"
  });
}

let make = List__Jsx3;

exports.iconFromType = iconFromType;
exports.make = make;
/* IconV5 Not a pure module */
